// extracted by mini-css-extract-plugin
export default {"viewBlock":"ColorSelector_viewBlock__xuZhz","popover":"ColorSelector_popover__7xFNC","cover":"ColorSelector_cover__TzPCS"};